import ResourcesCollectionProto from "./resources-collection-proto"
import GenericUpdate from "../../../app/home/notifications/model/models/generic/generic-update"
import Resources from "../resources";

export default class GenericUpdatesResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, GenericUpdate, options)
    }
}
